import { db, type EngineRunRecord } from './codexDB';
import type { EngineRunReport } from '@/engine/canonBundle';

export async function saveEngineRun(report: EngineRunReport, bundleHash: string): Promise<string> {
  const record: EngineRunRecord = {
    id: report.id,
    projectId: report.projectId,
    createdAt: report.createdAt,
    bundleHash,
    report,
  };
  await db.engineRuns.put(record);
  return record.id;
}

export async function listEngineRuns(projectId?: string): Promise<EngineRunRecord[]> {
  const runs = projectId
    ? await db.engineRuns.where('projectId').equals(projectId).toArray()
    : await db.engineRuns.toArray();
  return runs.sort((a, b) => b.createdAt - a.createdAt);
}

export async function getEngineRun(id: string): Promise<EngineRunRecord | undefined> {
  return db.engineRuns.get(id);
}
